import React from "react";
import { Button, Alert, Modal } from "react-bootstrap";
import HeaderLogin from "./../HeaderLogin/HeaderLogin.jsx";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { AccountCircle, VpnKey } from "@material-ui/icons";
import { connect } from "react-redux";
import {
  loginUserAction,
  loginUserActionNew,
  myProfileAction,
  getStripeSettingAction,
  getBillingSettingAction,
  updatetoken,
  getallpermissions,
} from "./../../actions/UserActions";
import { getSubscriptionCounterAction } from "./../../actions/SubscriptionReportAction";
import { cryptoTokenDecode } from "./../Common/Common";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Logo from "../../assets/img/logo.png";
import * as code from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../config/Constants.jsx";
var CryptoJS = require("crypto-js");

const initialValue = {
  userName: "",
  password: "",
};

class Login extends React.Component {
  constructor(props) {
    super(props);
    let currentType = localStorage.getItem("currentRole");
    this.state = {
      accountLocked: false,
      passwordNotSet: false,
      LoginMessage: undefined,
      showLoader: true,
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      chooseAccountowner: false,
      contactownerdata: [],
      selectedCompany: "",
      selectError: false,
      accessToken: "",
    };
  }

  componentWillMount() {
    //this.stripeSettingAction();
    this.billingSettingAction();
    this.setState({ LoginMessage: undefined });
  }
  // stripeSettingAction() {
  //   this.props.getStripeSettingAction().then((res) => {
  //     if (res.status == code.OK) {
  //       if (res.data[0].isSubscriptionEnabled) {
  //         localStorage.setItem(code.IS_STRIPE_ENABLED, "true");
  //       } else {
  //         localStorage.setItem(code.IS_STRIPE_ENABLED, "false");
  //       }
  //       this.setState({ showLoader: false });
  //     } else {
  //       this.setState({ showLoader: false });
  //     }
  //   });
  // }

  billingSettingAction() {
    this.props.getBillingSettingAction().then((res) => {
      if (res.status === code.OK) {
        if (res.data.isBillingEnabled) {
          localStorage.setItem(code.IS_BILLING_ENABLED, "true");
        } else {
          localStorage.setItem(code.IS_BILLING_ENABLED, "false");
        }
        this.setState({ showLoader: false });
      } else {
        this.setState({ showLoader: false });
      }
    });
  }

  /**
   * select and close popup
   * 11-5-2023
   */
  SelectAndClose() {
    // console.log("selected data", this.state.selectedCompany);
    let playload = cryptoTokenDecode();
    // console.log("playload", playload);

    if (this.state.selectedCompany === "") {
      this.setState({ selectError: true });
    } else if (playload._id == this.state.selectedCompany) {
      // means account owner select his own company.
      // means the usertype is accountowner.
      // and no need to update the token

      localStorage.getItem("accessToken");
      let playload = cryptoTokenDecode();
      localStorage.setItem("usertype", playload.usertype);
      localStorage.setItem("ID", playload._id);

      this.props.myProfileAction().then((res) => {
        //console.log('myProfileAction res',res);
        // if (
        //   cryptoTokenDecode().usertype === message.ACCTOWNER &&
        //   localStorage.getItem(code.IS_STRIPE_ENABLED) === "true"
        // ) {
        //   this.props.getSubscriptionCounterAction().then((counterRes) => {
        //     //console.log('getSubscriptionCounterAction res',counterRes);
        //     if (counterRes && counterRes[0] && counterRes[0].templateCounter) {
        //       localStorage.setItem(
        //         "templateCount",
        //         counterRes[0].templateCounter
        //       );
        //     }
        //     if (
        //       counterRes &&
        //       counterRes[0] &&
        //       counterRes[0].transactionLimitCounter
        //     ) {
        //       localStorage.setItem(
        //         "transactionCount",
        //         counterRes[0].transactionLimitCounter
        //       );
        //     }
        //     if (
        //       counterRes &&
        //       counterRes[0] &&
        //       counterRes[0].subscriptionLimit &&
        //       counterRes[0].subscriptionLimit.templateCounter
        //     ) {
        //       localStorage.setItem(
        //         "templateLimit",
        //         counterRes[0].subscriptionLimit.templateCounter
        //       );
        //     }
        //     if (
        //       counterRes &&
        //       counterRes[0] &&
        //       counterRes[0].subscriptionLimit &&
        //       counterRes[0].subscriptionLimit.transactionCounter
        //     ) {
        //       localStorage.setItem(
        //         "transactionLimit",
        //         counterRes[0].subscriptionLimit.transactionCounter
        //       );
        //     }
        //   });
        // }
      });
      if (localStorage.getItem("accessToken")) {
        this.postLogin();
      }

      // console.log("means account owner select his own company");
    } else {
      let selectedCompanyname = this.state.contactownerdata.find(
        (element) => element._id == String(this.state.selectedCompany)
      );
      // console.log("element282", selectedCompanyname);
      localStorage.setItem(
        "companyName",
        selectedCompanyname.companyInformation.name
      );
      localStorage.setItem("ownerId", this.state.selectedCompany);
      this.setState({ chooseAccountowner: false });
      // first set the token at local storage
      localStorage.setItem("accessToken", this.state.accessToken);
      let playload = cryptoTokenDecode();
      // console.log("playload379", playload);

      // than update a token with owner Id
      this.props.updatetoken(false).then((res) => {
        // console.log("res295", res.data);
        localStorage.setItem("accessToken", res.data);
        this.getVendorRole(res.data);

        let playload = cryptoTokenDecode();
        localStorage.setItem("usertype", playload.usertype);
        localStorage.setItem("ID", playload._id);

        // console.log("playload127", playload);
        if (playload.usertype === "VENDOR") {
          // find all permissions
          this.props.getallpermissions().then((res) => {
            // console.log("res110", res.data);
            localStorage.setItem("otherInfo", res.data);
            if (
              localStorage.getItem("accessToken") &&
              localStorage.getItem("otherInfo")
            ) {
              this.postLogin();
            }
          });
        }
      });

      this.props.myProfileAction().then((res) => {
        //console.log('myProfileAction res',res);
        // if (
        //   cryptoTokenDecode().usertype === message.ACCTOWNER &&
        //   localStorage.getItem(code.IS_STRIPE_ENABLED) === "true"
        // ) {
        //   this.props.getSubscriptionCounterAction().then((counterRes) => {
        //     //console.log('getSubscriptionCounterAction res',counterRes);
        //     if (counterRes && counterRes[0] && counterRes[0].templateCounter) {
        //       localStorage.setItem(
        //         "templateCount",
        //         counterRes[0].templateCounter
        //       );
        //     }
        //     if (
        //       counterRes &&
        //       counterRes[0] &&
        //       counterRes[0].transactionLimitCounter
        //     ) {
        //       localStorage.setItem(
        //         "transactionCount",
        //         counterRes[0].transactionLimitCounter
        //       );
        //     }
        //     if (
        //       counterRes &&
        //       counterRes[0] &&
        //       counterRes[0].subscriptionLimit &&
        //       counterRes[0].subscriptionLimit.templateCounter
        //     ) {
        //       localStorage.setItem(
        //         "templateLimit",
        //         counterRes[0].subscriptionLimit.templateCounter
        //       );
        //     }
        //     if (
        //       counterRes &&
        //       counterRes[0] &&
        //       counterRes[0].subscriptionLimit &&
        //       counterRes[0].subscriptionLimit.transactionCounter
        //     ) {
        //       localStorage.setItem(
        //         "transactionLimit",
        //         counterRes[0].subscriptionLimit.transactionCounter
        //       );
        //     }
        //   });
        // }
      });
    }
  }

  onChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  /**
   * @desc login api call and handling reponses
   * @param {*} data
   */
  loginAction(data) {
    data.userName = data.userName.trim().toLowerCase();
    data.password = data.password.trim();
    localStorage.setItem("userName", data.userName);
    this.props.loginUserActionNew(data).then((res) => {
      // This code is to show system banners
      const currentDate = new Date();
      if (!localStorage.getItem("lastOpenedDate")) {
        localStorage.setItem("lastOpenedDate", currentDate.toDateString());
      }
      if (localStorage.getItem("firstOpen") != "false") {
        localStorage.setItem("firstOpen", true);
      }
      localStorage.setItem("bannerDisplayed", false);
      //==============================till here system banners=========================
      if (res.status == code.OK) {
        // console.log("login_data88", res.data);
        if (
          res.data.contactOwner &&
          res.data.contactOwner.length === 1 &&
          res.data.usertype == "VENDOR"
        ) {
          localStorage.setItem("ownerId", res.data.contactOwner[0]._id);
          localStorage.setItem(
            "companyName",
            res.data.contactOwner[0].companyInformation.name
          );
          localStorage.setItem("accessToken", res.data.data);

          // than update a token with owner Id
          this.props.updatetoken(false).then((res) => {
            // console.log("updatetoken res295", res.data);
            localStorage.setItem("accessToken", res.data);
            this.getVendorRole(res.data);
            let playload = cryptoTokenDecode();
            // console.log("playload292", playload);
            localStorage.setItem("usertype", playload.usertype);
            localStorage.setItem("ID", playload._id);

            // console.log("playload127", playload);
            if (playload.usertype === "VENDOR") {
              // find all permissions
              this.props.getallpermissions().then((res) => {
                // console.log("res110", res.data);
                localStorage.setItem("otherInfo", res.data);
                if (
                  localStorage.getItem("accessToken") &&
                  localStorage.getItem("otherInfo")
                ) {
                  // setTimeout(this.postLogin(), 3000);
                  this.postLogin();
                }
              });
            }
          });

          this.props.myProfileAction().then((res) => {
            //console.log('myProfileAction res',res);
            // if (
            //   cryptoTokenDecode().usertype === message.ACCTOWNER &&
            //   localStorage.getItem(code.IS_STRIPE_ENABLED) === "true"
            // ) {
            //   this.props.getSubscriptionCounterAction().then((counterRes) => {
            //     //console.log('getSubscriptionCounterAction res',counterRes);
            //     if (
            //       counterRes &&
            //       counterRes[0] &&
            //       counterRes[0].templateCounter
            //     ) {
            //       localStorage.setItem(
            //         "templateCount",
            //         counterRes[0].templateCounter
            //       );
            //     }
            //     if (
            //       counterRes &&
            //       counterRes[0] &&
            //       counterRes[0].transactionLimitCounter
            //     ) {
            //       localStorage.setItem(
            //         "transactionCount",
            //         counterRes[0].transactionLimitCounter
            //       );
            //     }
            //     if (
            //       counterRes &&
            //       counterRes[0] &&
            //       counterRes[0].subscriptionLimit &&
            //       counterRes[0].subscriptionLimit.templateCounter
            //     ) {
            //       localStorage.setItem(
            //         "templateLimit",
            //         counterRes[0].subscriptionLimit.templateCounter
            //       );
            //     }
            //     if (
            //       counterRes &&
            //       counterRes[0] &&
            //       counterRes[0].subscriptionLimit &&
            //       counterRes[0].subscriptionLimit.transactionCounter
            //     ) {
            //       localStorage.setItem(
            //         "transactionLimit",
            //         counterRes[0].subscriptionLimit.transactionCounter
            //       );
            //     }
            //   });
            // }
          });
        } else if (res.data.usertype == "VENDOR") {
          // open the popup for choosing the account owner.
          // console.log("at else if");
          this.setState({
            chooseAccountowner: true,
            contactownerdata: res.data.contactOwner,
            accessToken: res.data.data,
          });
        } else if (
          res &&
          res.data.usertype == "ACCTOWNER" &&
          res.data.contactOwner.length > 1
        ) {
          // open the popup for choosing the account owner.
          // condition is if accountowner is a vendor to other accountowner.
          // console.log("res.data", res.data);
          // console.log("at else if ACCTOWNER");
          // console.log("res.data.contactOwner", res.data.contactOwner);
          this.setState({
            chooseAccountowner: true,
            contactownerdata: res.data.contactOwner,
            accessToken: res.data.data,
          });
          // temaprary set access token for account owner , to check condition.
          localStorage.setItem("accessToken", this.state.accessToken);
        } else {
          var accessToken = res.data.data;
          localStorage.setItem("accessToken", accessToken);
          var playload = cryptoTokenDecode();
          localStorage.setItem("usertype", playload.usertype);
          localStorage.setItem("ID", playload._id);

          this.props.myProfileAction().then((res) => {
            //console.log('myProfileAction res',res);
            // if (
            //   cryptoTokenDecode().usertype === message.ACCTOWNER &&
            //   localStorage.getItem(code.IS_STRIPE_ENABLED) === "true"
            // ) {
            //   this.props.getSubscriptionCounterAction().then((counterRes) => {
            //     //console.log('getSubscriptionCounterAction res',counterRes);
            //     if (
            //       counterRes &&
            //       counterRes[0] &&
            //       counterRes[0].templateCounter
            //     ) {
            //       localStorage.setItem(
            //         "templateCount",
            //         counterRes[0].templateCounter
            //       );
            //     }
            //     if (
            //       counterRes &&
            //       counterRes[0] &&
            //       counterRes[0].transactionLimitCounter
            //     ) {
            //       localStorage.setItem(
            //         "transactionCount",
            //         counterRes[0].transactionLimitCounter
            //       );
            //     }
            //     if (
            //       counterRes &&
            //       counterRes[0] &&
            //       counterRes[0].subscriptionLimit &&
            //       counterRes[0].subscriptionLimit.templateCounter
            //     ) {
            //       localStorage.setItem(
            //         "templateLimit",
            //         counterRes[0].subscriptionLimit.templateCounter
            //       );
            //     }
            //     if (
            //       counterRes &&
            //       counterRes[0] &&
            //       counterRes[0].subscriptionLimit &&
            //       counterRes[0].subscriptionLimit.transactionCounter
            //     ) {
            //       localStorage.setItem(
            //         "transactionLimit",
            //         counterRes[0].subscriptionLimit.transactionCounter
            //       );
            //     }
            //   });
            // }
          });
          if (localStorage.getItem("accessToken")) {
            this.postLogin();
          }
        }
      } else {
        this.setState({
          LoginMessage: this.props.LoginMessage,
        });
      }

      if (
        res.status === code.FORBIDDEN &&
        res.data === "Your account is deactivated."
      ) {
        this.setState({
          LoginMessage: message.DEACTIVATE,
        });
      }

      if (res.status === code.FORBIDDEN && res.data === "Account locked.") {
        this.setState({
          LoginMessage: message.YOUR_ACCOUNT_LOCKED,
          accountLocked: true,
        });
      }
      if (res.status === code.BAD_REQUEST && res.data === "Password not set") {
        localStorage.setItem("PS", false);
        this.setState({
          LoginMessage: message.ACCESS_PWD_NOT_SET,
          passwordNotSet: true,
          accountLocked: true,
        });
      }
    });
  }

  getVendorRole(accessToken) {
    let playload = "";
    let bytes = CryptoJS.AES.decrypt(accessToken, REACT_APP_CRYPTO_SECRET_KEY);
    let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    // console.log('decryptedData',decryptedData);
    playload = JSON.parse(atob(decryptedData.split(".")[1]));
    // console.log('playload',playload);
    localStorage.setItem("vendorRoleName", playload.roleName);
  }

  /**
   * @desc post login actions - redirection to page based on user type
   */
  postLogin() {
    let userType = cryptoTokenDecode().usertype;
    if (userType !== null && userType.toUpperCase() === message.ADMIN) {
      this.props.history.push("/RegistrationRequests");
    } else if (
      userType !== null &&
      userType.toUpperCase() === message.ACCTOWNER
    ) {
      if (window.innerWidth > 768) {
        this.props.history.push("/artwork");
      } else {
        this.props.history.push("/artwork");
      }
    } else {
      this.props.history.push("/artwork");
    }
  }

  goToRegister() {
    this.props.history.push("/register");
  }
  goToForgotPassword() {
    if (this.state.passwordNotSet) {
      this.props.history.push("/resetpassword/setpass");
    } else {
      this.props.history.push("/forgotpassword");
    }
  }
  goToForgotUserName() {
    this.props.history.push("/forgotuserName");
  }
  render() {
    return (
      <>
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <div>
          <HeaderLogin />
          <div className="loginBg loginContent align-items-end flex-column">
            <div className="loginBox">
              <h4>Login</h4>
              {this.state.LoginMessage !== undefined && (
                <Alert variant="danger">
                  {this.state.LoginMessage
                    ? this.state.LoginMessage
                    : this.props.LoginMessage}
                </Alert>
              )}
              {!this.state.accountLocked &&
              this.state.passwordNotSet == false ? (
                <Formik
                  validateOnBlur={true}
                  initialValues={initialValue}
                  enableReinitialize={true}
                  validationSchema={Yup.object().shape({
                    userName: Yup.string()
                      .required(message.ENTER_USER_NAME)
                      .matches(new RegExp("^[a-z][a-z0-9@._]*$"), {
                        message: message.ENTER_VALID_USER_NAME,
                      }),
                    password: Yup.string()
                      .nullable()
                      .trim()
                      .required(message.ENTER_PASSWORD)
                      .min(6, message.PASSWORD_LENGTH),
                  })}
                  onSubmit={(values, { setSubmitting }) => {
                    this.loginAction(values);
                  }}
                >
                  {({ errors, values, touched }) => (
                    <Form>
                      <div className="form-group">
                        <label className="form-label" htmlFor="userName">
                          Username
                        </label>
                        <div className="icon-wrapper input-group">
                          <Field
                            type="text"
                            name="userName"
                            value={values.userName}
                            className={
                              "form-control form-control-lg" +
                              (errors.userName && touched.userName
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <span className="form-control-icn">
                            <AccountCircle />
                          </span>
                          <ErrorMessage
                            name="userName"
                            component="div"
                            className="invalid-feedback"
                            style={{ display: "block", color: "white" }}
                          />
                        </div>
                      </div>

                      <div className="form-group mb-0">
                        <label className="form-label" htmlFor="password">
                          Password
                        </label>
                        <div className="icon-wrapper input-group">
                          <Field
                            name="password"
                            type="password"
                            value={values.password}
                            className={
                              "form-control form-control-lg " +
                              (errors.password && touched.password
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <span className="form-control-icn">
                            <VpnKey />
                          </span>
                          <ErrorMessage
                            name="password"
                            component="div"
                            className="invalid-feedback"
                            style={{ display: "block", color: "white" }}
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <Button
                          variant="link"
                          className="pr-0 font-14 font-500 float-left"
                          style={{ color: "#FFFFFF", padding: "6px 0" }}
                          onClick={() => this.goToForgotUserName()}
                        >
                          Forgot Username?
                        </Button>
                        <Button
                          variant="link"
                          className="pr-0 font-14 font-500 float-right"
                          style={{ color: "#FFFFFF", padding: "6px 0" }}
                          onClick={() => this.goToForgotPassword()}
                        >
                          Forgot Password?
                        </Button>
                      </div>

                      <div className="form-group pt-2">
                        <Button
                          type="submit"
                          variant="primary"
                          size="lg"
                          block
                          className="btn-blue btn-medium"
                        >
                          Login
                        </Button>
                      </div>

                      <div className="form-group pt-4 text-center mb-0">
                        <span className="font-14 color-grey-1 font-300">
                          Don't have an account?
                        </span>{" "}
                        <Button
                          variant="link"
                          className="pl-0 pr-0 font-14 font-500"
                          style={{ color: "#FFFFFF" }}
                          onClick={() => this.goToRegister()}
                        >
                          Register
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              ) : (
                <Button
                  variant="link"
                  className="pr-0 font-14 font-500"
                  style={{ color: "#4a90e2" }}
                  onClick={() => this.goToForgotPassword()}
                >
                  {" "}
                  Click here to create a password.
                </Button>
              )}
            </div>
          </div>
        </div>

        {/* modal popup for chossing account owners */}
        <Modal
          show={this.state.chooseAccountowner}
          // onHide={() => closeInvoicePrompt()}
          onHide={() =>
            this.setState({
              chooseAccountowner: !this.state.chooseAccountowner,
            })
          }
          aria-labelledby="example-custom-modal-styling-title"
          backdrop={false}
          size="md"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Choose Studio
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pb-4">
            <label>Select Studio</label>
            <div>
              <FormControl sx={{ m: 0, width: 300 }} size="large">
                <InputLabel id="demo-select-large">Studio</InputLabel>
                <Select
                  labelId="company"
                  id="company"
                  label="Page"
                  onChange={(e) =>
                    this.setState({ selectedCompany: e.target.value })
                  }
                >
                  {this.state.contactownerdata &&
                    this.state.contactownerdata.map((item) => {
                      return (
                        <MenuItem value={item._id}>
                          {item.companyInformation.name}
                        </MenuItem>
                      );
                    })}
                </Select>
                {this.state.selectError ? (
                  <p style={{ color: "red" }}> Please select any studio</p>
                ) : (
                  ""
                )}
              </FormControl>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <Button
                onClick={() => {
                  this.SelectAndClose();
                }}
                className="btn btn-primary btn-blue btn-head w-140 mr-3"
              >
                Continue
              </Button>
              <Button
                onClick={() => {
                  this.setState({
                    chooseAccountowner: !this.state.chooseAccountowner,
                  });
                }}
                className="btn btn-primary btn-blue btn-head w-140"
              >
                Cancel
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.reducer.isAuthenticated,
    LoginMessage: state.reducer.LoginMessage,
    stripeEnable: state.reducer.stripeEnable,
  };
};

export default connect(
  mapStateToProps,
  {
    loginUserAction,
    loginUserActionNew,
    myProfileAction,
    getSubscriptionCounterAction,
    getStripeSettingAction,
    getBillingSettingAction,
    updatetoken,
    getallpermissions,
  }
)(Login);
